import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Avertissement — bouclier avec point d'exclamation doux.
 * Style PayFit : bouclier rempli warning, garde + ! en bleu primary.
 * Plus apaisé qu'un triangle classique, conserve la sémantique attention.
 */
export const WarningIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Bouclier rempli (warning tint) */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        fill="hsl(var(--warning))" fillOpacity="0.85"
      />
      {/* Contour bleu primary */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Point d'exclamation */}
      <path d="M12 8.5v4.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" />
      <circle cx="12" cy="16" r="1" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
WarningIcon.displayName = "WarningIcon";
